export default "__VITE_ASSET__7ce75b6a__"